import { render, staticRenderFns } from "./SelectIdentifier.vue?vue&type=template&id=5a4c7b21"
import script from "./SelectIdentifier.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectIdentifier.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4c7b21')) {
      api.createRecord('5a4c7b21', component.options)
    } else {
      api.reload('5a4c7b21', component.options)
    }
    module.hot.accept("./SelectIdentifier.vue?vue&type=template&id=5a4c7b21", function () {
      api.rerender('5a4c7b21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/group/identifier/components/SelectIdentifier.vue"
export default component.exports